import {LabelValue} from '@/components-v2/molecules'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {PromotionReviewSection} from './PromotionReviewSection'

/**
 * @param {{
 *  promotionReviewData: import('@/types/promotion').Promotion,
 * }} props
 */
export const PromotionReviewAdditionalInformation = ({promotionReviewData}) => {
  const {isDuplicating} = usePromotion()

  return (
    <PromotionReviewSection label="Additional Information" showEdit={false}>
      <div className="flex w-full flex-col gap-6 overflow-hidden">
        <div className="grid grid-cols-3 gap-x-4">
          <LabelValue keyName="Promotion ID" val={isDuplicating ? '-' : promotionReviewData?.id || '-'} />
          <LabelValue
            keyName="Promotion External ID"
            val={isDuplicating ? '-' : promotionReviewData?.externalPromotionId || '-'}
          />
          <LabelValue
            keyName="External ID"
            val={isDuplicating ? '-' : promotionReviewData?.externalId || '-'}
          />
        </div>
        <div className="grid grid-cols-3 gap-x-4">
          <LabelValue
            keyName="Conditional External ID"
            val={isDuplicating ? '-' : promotionReviewData?.conditionalExternalId || '-'}
          />
          <LabelValue
            keyName="Benefit External ID"
            val={isDuplicating ? '-' : promotionReviewData?.benefitExternalId || '-'}
          />
        </div>
      </div>
    </PromotionReviewSection>
  )
}
